module.exports = __webpack_public_path__ + "img/ico-free.330187eb.png";